/* eslint-disable import/prefer-default-export */
import * as form from '../form';

export const legalPoliceOffenses = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Has: form.branch(xitem.Has),
        Date: form.datecontrol(xitem.Date),
        Description: form.textarea(xitem.Description),
        InvolvedViolence: form.branch(xitem.InvolvedViolence),
        InvolvedFirearms: form.branch(xitem.InvolvedFirearms),
        InvolvedSubstances: form.branch(xitem.InvolvedSubstances),
        InvolvedAlcohol: form.branch(xitem.InvolvedAlcohol),
        InvolvedExplosives: form.branch(xitem.InvolvedExplosives),
        Address: form.location(xitem.Address),
        WasCited: form.branch(xitem.WasCited),
        CitedBy: form.text(xitem.CitedBy),
        AgencyAddress: form.location(xitem.AgencyAddress),
        WasCharged: form.branch(xitem.WasCharged),
        Explanation: form.textarea(xitem.Explanation),
        CourtName: form.text(xitem.CourtName),
        CourtAddress: form.location(xitem.CourtAddress),
        CourtStatus: form.branch(xitem.CourtStatus),
        CourtFinePayment: form.branch(xitem.CourtFinePayment),
        CourtFineAmount: form.text(xitem.CourtFineAmount),
        CourtFinePaidInFull: form.branch(xitem.CourtFinePaidInFull),
        CourtFinePaidInFullDate: form.datecontrol(xitem.CourtFinePaidInFullDate),
        CourtFineNotPaidInFullExplanation: form.textarea(xitem.CourtFineNotPaidInFullExplanation),
        CourtToAppear: form.text(xitem.CourtToAppear),
        CourtToAppearAddress: form.location(xitem.CourtToAppearAddress),
        Charges: form.collection(
          ((xitem.Charges || {}).items || []).map((y) => {
            const yItem = y.Item || {};
            return {
              Item: {
                CourtCharge: form.text(yItem.CourtCharge),
                CourtOutcome: form.text(yItem.CourtOutcome),
                CourtDate: form.datecontrol(yItem.CourtDate),
                ChargeType: form.radio(yItem.ChargeType),
                ChargeTypeOtherExplanation: form.textarea(yItem.ChargeTypeOtherExplanation),
                CourtOutcomeOtherExplanation: form.textarea(yItem.CourtOutcomeOtherExplanation),
                CourtRequirementsOtherExplanation: form.textarea(yItem.CourtRequirementsOtherExplanation),
                CourtOutcomeDismissedRequirements: form.checkboxgroup(yItem.CourtOutcomeDismissedRequirements),
                WasSentenced: form.branch(yItem.WasSentenced),
                Sentence: form.sentence(yItem.Sentence),
                SentencingDate: form.datecontrol(yItem.SentencingDate),
                SentenceJudgements: form.checkboxgroup(yItem.SentenceJudgements),
                SentenceJudgementOtherExplanation: form.textarea(yItem.SentenceJudgementOtherExplanation),
                CourtOutcomeOnTrialExplanation: form.textarea(yItem.CourtOutcomeOnTrialExplanation),
              },
            };
          }),
          (xitem.Charges || {}).branch
        ),
        WasSentenced: form.branch(xitem.WasSentenced),
        Sentence: form.sentence(xitem.Sentence),
        AwaitingTrial: form.branch(xitem.AwaitingTrial),
        AwaitingTrialExplanation: form.textarea(xitem.AwaitingTrialExplanation),
        OtherLawEnforcementAgency: form.branch(xitem.OtherLawEnforcementAgency),
        ArrestingAgencyName: form.text(xitem.ArrestingAgencyName),
        ArrestingAgencyAddress: form.location(xitem.ArrestingAgencyAddress),
        CaseClosed: form.branch(xitem.CaseClosed), // PVQ Only
        CaseClosedDate: form.datecontrol(xitem.CaseClosedDate), // PVQ Only
        CaseClosedStatusExplanation: form.textarea(xitem.CaseClosedStatusExplanation), // PVQ Only
      },
    };
  });
  return {
    List: form.collection(items, (data.List || {}).branch),
    HasCitationLastXYears: form.branch(data.HasCitationLastXYears), // PVQ Only - Part A
    HasChargesLastXYears: form.branch(data.HasChargesLastXYears), // PVQ Only - Part A
    HasProbationLastXYears: form.branch(data.HasProbationLastXYears), // PVQ Only - Part A
    HasParoleLastXYears: form.branch(data.HasParoleLastXYears), // PVQ Only - Part A
    HasChargesInvolvingFirearmsMoreThanXYears: form.branch(data.HasChargesInvolvingFirearmsMoreThanXYears), // PVQ Only - Part B
    HasDomesticViolenceMoreThanXYears: form.branch(data.HasDomesticViolenceMoreThanXYears), // PVQ Only - Part B
    HasFelonyMoreThanXYears: form.branch(data.HasFelonyMoreThanXYears), // PVQ Only - Part B
  };
};
